var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }
import { styled } from '@mui/material/styles';
import scStyled, { css } from 'styled-components';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { mixColors, hexToRgba } from '../utils/colors';
var borderRadius = function borderRadius(edges, theme) {
  switch (edges) {
    case 'rounded':
      return 99;
    case 'sharp':
      return 0;
    default:
      return theme.shape.borderRadius;
  }
};
export var StyledRoot = styled(Box)(function (_ref) {
  var disabled = _ref.disabled,
    edges = _ref.edges,
    errors = _ref.errors,
    theme = _ref.theme;
  return {
    padding: '1rem 1.5rem 0.8rem 1.5rem',
    marginBottom: '0.25rem',
    color: theme.palette.text.primary,
    position: 'relative',
    border: "2px dashed " + (errors === 'yes' ? theme.palette.error.main : theme.palette.primary.main),
    background: disabled ? theme.palette.grey[300] : null,
    opacity: disabled ? 0.5 : 1,
    borderRadius: borderRadius(edges, theme),
    '& img': {
      width: '100%',
      height: 'auto',
      display: 'block'
    },
    '&:focus': {
      border: "2px solid " + theme.palette.primary.main,
      outline: 'none',
      background: hexToRgba(theme.palette.primary.main, 0.1)
    },
    '& .ReactCrop__crop-selection::before': {
      content: "''"
    }
  };
});
export var StyledLinearProgress = styled(LinearProgress)(function (_ref2) {
  var isDragReject = _ref2.isDragReject,
    theme = _ref2.theme;
  return {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    opacity: 0.2,
    backgroundColor: isDragReject ? theme.palette.error.main : theme.palette.primary.main,
    '& .MuiLinearProgress-barColorPrimary': {
      background: mixColors(isDragReject ? theme.palette.error.main : theme.palette.primary.main, '#ffffff', 60)
    }
  };
});
export var StyledCircularProgress = styled(CircularProgress)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  marginTop: -20,
  marginLeft: -20
});
export var StyledAvatar = styled('div')(function (_ref3) {
  var src = _ref3.src,
    theme = _ref3.theme;
  return {
    backgroundColor: theme.palette.grey.transparent,
    backgroundImage: src ? "url(" + src + ")" : null,
    borderRadius: '50%',
    overflow: 'hidden',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    height: '100%',
    width: '100%'
  };
});
export var StyledAvatarIcon = styled('div')(function (_ref4) {
  var theme = _ref4.theme;
  return {
    textAlign: 'center',
    display: 'inline-block',
    padding: 20,
    marginBottom: 10,
    height: 110,
    width: 110,
    position: 'relative',
    '& svg': {
      width: '100%',
      maxWidth: 150,
      height: 'auto',
      color: theme.palette.grey.main,
      display: 'block'
    }
  };
});
export var StyledDeleteIcon = scStyled.span(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    top: 50%;\n    right: 25px;\n    z-index: 9;\n    background: transparent;\n    color: ", ";\n    width: 48px;\n    height: 48px;\n    margin-top: -12px;\n    font-size: 20px;\n    transition: all 0.25s ease-in-out;\n    transform: translateY(-50%) scale(0.9);\n    box-shadow: ", ";\n    border-radius: 50%;\n    &:hover {\n      background: rgba(0, 0, 0, 0.04);\n      transform: translateY(-50%) scale(1.05);\n      color: ", ";\n      box-shadow: ", ";\n    }\n  "])), theme.palette.grey.main, theme.shadows[2], theme.palette.secondary.main, theme.shadows[4]);
});
export var StyledAddIcon = scStyled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref6) {
  var theme = _ref6.theme;
  return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n    display: inline-flex;\n    width: 12px;\n    height: 12px;\n    justify-content: center;\n    align-items: center;\n    border-radius: 50%;\n    background: ", ";\n    color: ", ";\n    box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.4);\n    position: absolute;\n    right: 12px;\n    z-index: 2;\n    bottom: 8px;\n  "])), theme.palette.background.paper, theme.palette.primaryAlt.main);
});